"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErrorMessageOfResponse = exports.EnhancedFetchError = void 0;
const enhancedFetch_1 = require("./enhancedFetch");
class EnhancedFetchError extends Error {
    constructor(msg, response) {
        super(msg);
        this.response = response;
    }
}
exports.EnhancedFetchError = EnhancedFetchError;
function createErrorMessageOfResponse(response) {
    return __awaiter(this, void 0, void 0, function* () {
        const responseErrors = yield enhancedFetch_1.getResponseErrors(response);
        const errors = [];
        Object.keys(responseErrors)
            .forEach((errorAttribute) => {
            errors.push(`${errorAttribute !== 'main' ? `${errorAttribute}: ` : ''}${responseErrors[errorAttribute]}`);
        });
        return errors.join('\n');
    });
}
exports.createErrorMessageOfResponse = createErrorMessageOfResponse;
